// import utils from "@/eco-ui-util.js";
import req from "@/request.js";
// const portal = req.getContext().portal;
// const uc = req.getContext().uc;
// const business = req.getContext().business;
const work = req.getContext().work;

export default {
  // 获取模板库列表
  getProcessTemplate(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${work}/planning/process_template/query_public_list`,
          method: "GET",
          data: params
        })
        .then(response => {
          resolve(response.data);
          // resolve(utils.tile2nest(response.data));
        });
    });
  },
  // 获取我的模板列表
  getMyProcessTemplate(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${work}/planning/process_template/query_my_template_list/1`,
          method: "GET",
          data: params
        })
        .then(response => {
          resolve(response.data);
          // resolve(utils.tile2nest(response.data));
        });
    });
  },
  // 删除工序
  delProcessDetailTemplate(params) {
    return new Promise(resolve => {
      req
        .request({
          url: `${work}/planning/process_detail_template/delete_process`,
          method: "POST",
          data: params
        })
        .then(response => {
          resolve(response.data);
          // resolve(utils.tile2nest(response.data));
        });
    });
  },
  // 获取模板下子级
  getTemplateDetail(params) {
    return new Promise((resolve, reject) => {
      req
        .get(`${work}/planning/process_template/templateDetail/${params}`)
        .then(
          response => {
            resolve(response.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
  // 获取模板下子级
  getPublicTemplateDetail(params) {
    return new Promise((resolve, reject) => {
      req.get(`${work}/planning/process_template/public_template_detail/${params}`)
        .then(
          response => {
            resolve(response.data);
          },
          error => {
            reject(error);
          }
        );
    });
  },
};
